import React from 'react';
import PropTypes from 'prop-types';
import NavigationPrompt from 'react-router-navigation-prompt';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
} from 'components/common/Dialog';

import Button from 'components/common/Button';

const styles = theme => ({
  message: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    minHeight: 200,
    padding: '0 86px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 8px 8px',
      textAlign: 'center',
      height: 'calc(100vh - 55px)',
    },
  },
});

const Prompt = ({
  when,
  message,
  submitButtontext,
  cancelButtontext,
  classes,
}) => (
  <NavigationPrompt when={when}>
    {({ onConfirm, onCancel }) => (
      <Dialog
        open
        maxWidth="sm"
      >
        <DialogContent>
          <div className={classes.message}>
            <Typography
              variant="subheading"
              color="secondary"
            >
              {message}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onCancel}
            variant="raised"
          >
            {cancelButtontext}
          </Button>
          <Button
            onClick={onConfirm}
            variant="raised"
            color="primary"
          >
            {submitButtontext}
          </Button>
        </DialogActions>
      </Dialog>
    )}
  </NavigationPrompt>
);

Prompt.propTypes = {
  when: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  message: PropTypes.string.isRequired,
  submitButtontext: PropTypes.string,
  cancelButtontext: PropTypes.string,
  classes: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }).isRequired,
};

Prompt.defaultProps = {
  when: true,
  submitButtontext: 'Ok',
  cancelButtontext: 'Cancel',
};

export default withStyles(styles)(Prompt);



// WEBPACK FOOTER //
// ./src/components/common/Prompt.js